export const capitalized = text => {
  return (text.charAt(0).toUpperCase() + text.slice(1)).replaceAll("_", " ");
};

export const createOption = value => {
  return {
    label: capitalized(value),
    value,
  };
};
